import React, {Component, Ref} from "react"
import styled from "styled-components"
import withAuth, {WithAuth} from "@irati/auth/helpers/auth/withAuth"

import Button from "@irati/ui/src/Button"
import ProfilePic from "@irati/ui/src/ProfilePicture"
import id from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"

import ProfilePicPopup from "../Popup/ProfilePic"

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: ${({theme}) => theme.spacing.four};
`

interface Props extends WithAuth {
  id: string
}

class EditProfilePic extends Component<Props> {
  static defaultProps = {
    id: "editProfilePic"
  }

  popup: Ref<ProfilePicPopup> = null

  getText = () => {
    const {
      auth: {user}
    } = this.props
    return user.profileImageUrl ? (
      <FormattedMessage id="account.profile.fields.picture.editButton" />
    ) : (
      <FormattedMessage id="account.profile.fields.picture.addButton" />
    )
  }

  handleShow = () => this.popup?.show()

  render() {
    const {
      auth: {user}
    } = this.props

    return (
      <div>
        <Container>
          <ProfilePic id={id("picture", this.props)} user={user} large />
          <Button id={id("btn", this.props)} onClick={this.handleShow} marginLeft={2} small>
            {this.getText()}
          </Button>
        </Container>
        <ProfilePicPopup
          ref={(c: Ref<ProfilePicPopup>) => {
            this.popup = c
          }}
          user={user}
        />
      </div>
    )
  }
}

export default withAuth(EditProfilePic)
